import React, { useState, useEffect } from "react";
import "./Product.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import CartIcon from "../../../Components/CartIcon/CartIcon";
import { FaHeart } from "react-icons/fa";
import { useAuth } from "../../../AuthContext";
import useCart from "../../../Hooks/useCart";
import { useNavigate, useLocation } from "react-router-dom";
import Slider from "../../../Components/Slider/Slider";
import { MdClose } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import Axios from "axios";
import Loading from "../../../Components/Loading/Loading";
import Alert from "../../../Components/Alert/Alert";
import useFavorites from "../../../Hooks/useFavorites";
import { useBaseUrl } from "../../../ApiContext";

export default function Product() {
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = useBaseUrl();
  const { baseId, productId, categorySlug } = location.state || {};
  const { userToken } = useAuth();
  const { cart, setCart } = useCart(userToken);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [modalText, setModalText] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const { favorites, setFavorites } = useFavorites(userToken);
  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState(null);
  const [editableAttributes, setEditableAttributes] = useState(null);
  const [selectedEditableAttr, setSelectedEditableAttr] = useState([]);
  const [forcedAttributes, setForcedAttributes] = useState(null);
  const [editableAttrString, setEditableAttrString] = useState("");
  const [forcedAttrString, setForcedAttrString] = useState("");
  const [isFavoriteProduct, setIsFavoriteProduct] = useState(false);
  const [purchaseData, setPurchaseData] = useState(null);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleShowModal = (row) => {
    setShowModal(true);
    setModalHeader(row.title);
    setModalText(row.text);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  const fetchCart = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/cart`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setCart(response.data);
    } catch (error) {
      console.log("Error during getting cart data", error);
    }
  };

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/product-variant/${productId}/attributes`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setEditableAttributes(response.data.editable_attributes);
        setForcedAttributes(response.data.forced_attributes);
      } catch (error) {
        console.log("Error during getting product attributes", error);
      }
    };

    const fetchProductDetails = async () => {
      try {
        let response;
        if (categorySlug) {
          response = await Axios.get(
            `${baseUrl}/shop/digikala/${categorySlug}/product-varients?product_page=true`,
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
        } else {
          response = await Axios.get(
            `${baseUrl}/shop/base_products/${baseId}/product-varients?product_page=true`,
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
        }
        if (response.data) {
          const mainProduct = response.data.products.filter(
            (product) => product.id === productId
          )[0];
          setProductData(mainProduct);
        }
      } catch (error) {
        console.log("Error during getting product variants", error);
      }
    };

    if (userToken) {
      fetchAttributes();
      fetchProductDetails();
    }
  }, [baseUrl, userToken]);

  const fetchSelectedAttr = async () => {
    try {
      const response = await Axios.get(
        `${baseUrl}/shop/base_products/${baseId}/product-varients-purchase?attributes=${forcedAttrString}${
          forcedAttrString && editableAttrString && ","
        }${editableAttrString}`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      if (response.data.products.length > 0) {
        const purchase = response.data.products[0];
        setPurchaseData(purchase);
      } else {
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("موجود نمی باشد");
        setPurchaseData(null);
      }
    } catch (error) {
      console.log("Error during getting selected attributes", error);
    }
  };

  useEffect(() => {
    if (forcedAttrString || editableAttrString) {
      fetchSelectedAttr();
    }
  }, [forcedAttrString, editableAttrString]);

  const selectAttribute = (slug, selectedValue) => {
    const updatedSelectedEditableAttr = selectedEditableAttr.map((item) => {
      if (item.slug === slug) {
        return { ...item, value: selectedValue };
      }
      return item;
    });
    setSelectedEditableAttr(updatedSelectedEditableAttr);

    const selectedAttributes = updatedSelectedEditableAttr.map(
      (attr) => `(${attr.slug},${attr.value})`
    );
    setEditableAttrString(selectedAttributes.join(","));
  };

  useEffect(() => {
    if (editableAttributes && editableAttributes.length > 0) {
      const defaultSelectedValues = editableAttributes.map((attr) => ({
        slug: attr.slug,
        name: attr.name,
        value: attr.values[0],
      }));
      setSelectedEditableAttr(defaultSelectedValues);

      const selectedAttributes = defaultSelectedValues.map(
        (attr) => `(${attr.slug},${attr.value})`
      );
      setEditableAttrString(selectedAttributes.join(","));
    }
  }, [editableAttributes]);

  useEffect(() => {
    if (forcedAttributes && forcedAttributes.length > 0) {
      const formattedForcedValues = formatArrayToString(forcedAttributes);
      setForcedAttrString((prevState) => {
        if (prevState && prevState.includes(formattedForcedValues)) {
          return prevState;
        } else {
          return `${prevState}${prevState && ","}${formattedForcedValues}`;
        }
      });
    }
  }, [forcedAttributes]);

  const formatArrayToString = (arr) => {
    return arr.map((item) => `(${item.slug},${item.value})`).join(",");
  };

  const addToCardHandler = async (purchaseId) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/cart/add_item`,
        { id: purchaseId, quantity: 1 },
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 2000);
      setAlertText("به سبد خرید اضافه شد");
      fetchCart();
    } catch (error) {
      console.log("Error during adding item to cart", error);
    }
  };

  useEffect(() => {
    if (productData && editableAttributes && forcedAttributes && purchaseData) {
      setIsLoading(false);
    }
  }, [productData, editableAttributes, forcedAttributes, purchaseData]);

  const fetchFavorites = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/favorite`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setFavorites(response.data.item_set);
    } catch (error) {
      console.log("Error during getting favorites", error);
    }
  };

  const handleHeartClick = async () => {
    const isFavorite = favorites.some(
      (favorite) => favorite.product.id === productId
    );
    let postData;
    let alert;
    if (isFavorite) {
      postData = {
        id: productId,
        quantity: 0,
      };
      alert = "از علاقه مندی ها حذف شد";
      setIsFavoriteProduct(false);
    } else {
      postData = {
        id: productId,
        quantity: 1,
      };
      alert = "به علاقه مندی ها اضافه شد";
      setIsFavoriteProduct(true);
    }
    try {
      const response = await Axios.post(
        `${baseUrl}/favorite/add_item`,
        postData,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 2000);
      setAlertText(alert);
      fetchFavorites();
    } catch (error) {
      console.log("Error during adding to favorites", error);
    }
  };

  useEffect(() => {
    const isFavorite = favorites.some(
      (favorite) => favorite.product.id === productId
    );
    if (isFavorite) {
      setIsFavoriteProduct(true);
    }
  }, [favorites]);

  const handleOpenMagazine = () => {
    navigate("/magazine", { state: { magazineId: productData.journal } });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay productContainer">
        <div className="pageWrapper productOverlay">
          <div className="productHeader pageHeader centeredFlex">
            <div className="productHeaderRight centeredFlex">
              <BackBtn />
              <CartIcon {...cart} />
              <FaHeart
                className="favoriteIcon"
                onClick={handleHeartClick}
                style={
                  isFavoriteProduct ? { color: "#ff4545" } : { color: "#fff" }
                }
              />
              {productData && productData.journal && (
                <img
                  src="/images/book.png"
                  alt="book"
                  className="bookIcon"
                  onClick={handleOpenMagazine}
                />
              )}
            </div>
            <div className="productHeaderLeft centeredFlex">
              <img
                src="/images/ic_support_agent.svg"
                alt="support"
                className="supportAgentIcon"
                onClick={() => navigate("/tickets")}
              />
              <div
                className="supportAlert"
                onClick={() => navigate("/tickets")}
              >
                <p>ارتباط با پشتیبانی</p>
              </div>
              <img
                src="/images/ic_menu.svg"
                alt="menu"
                className="menuIcon"
                onClick={hamburgerMenuHandler}
              />
            </div>
          </div>
          <div className="productDetails scroll">
            {!isLoading && productData && productData.images.length > 0 && (
              <Slider images={productData && productData.images} />
            )}

            <h4
              className="productDetailsTitle horizontalBorder"
              style={
                productData && productData.images.length > 1
                  ? { paddingTop: "2.2rem" }
                  : { paddingTop: "0.875rem" }
              }
            >
              {!isLoading && productData ? productData.title : "نام محصول"}
            </h4>
            {!isLoading && forcedAttributes && forcedAttributes.length > 0 && (
              <div className="productAttributes">
                <p className="productAttributesTitle">ویژگی محصول</p>
                <div className="productAttributesWrapper centeredFlex scroll">
                  {forcedAttributes.map((attribute) => (
                    <div key={attribute.slug} className="productAttribute">
                      {attribute.name} : {attribute.value}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!isLoading &&
              editableAttributes &&
              editableAttributes.length > 0 && (
                <div className="productAttributes">
                  <p className="productAttributesTitle">ویژگی های انتخابی</p>
                  {editableAttributes.map((attribute) => (
                    <div
                      key={attribute.slug}
                      className="editableAttrWrapper centeredFlex"
                    >
                      <p className="editableAttrName">{attribute.name}</p>
                      <div className="editableAttrValues centeredFlex scroll">
                        {attribute &&
                          attribute.values &&
                          attribute.values.length > 0 &&
                          attribute.values.map((value, index) => (
                            <p
                              key={value}
                              className={`productAttribute ${
                                selectedEditableAttr &&
                                selectedEditableAttr.length > 0 &&
                                selectedEditableAttr.filter(
                                  (item) => item.name === attribute.name
                                )[0].value === value
                                  ? "selectedAttribute"
                                  : ""
                              }`}
                              onClick={() =>
                                selectAttribute(attribute.slug, value)
                              }
                            >
                              {value}
                            </p>
                          ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}

            <div className="productAttributes">
              {productData && productData.detail_specific && (
                <p className="productAttributesTitle">مشخصات محصول</p>
              )}
              {!isLoading && (
                <div className="productSpecifications">
                  {productData &&
                    productData.detail_specific &&
                    productData.detail_specific.rows.map((row) => (
                      <div
                        key={row.title}
                        className="productSpecific centeredFlex"
                      >
                        <span className="productSpecificTitle">
                          {row.title}
                        </span>
                        <span
                          className="productSpecificText"
                          onClick={() => handleShowModal(row)}
                        >
                          {row.text}
                        </span>
                      </div>
                    ))}
                </div>
              )}
            </div>
            {isLoading && <Loading />}
          </div>
          {!isLoading && purchaseData && (
            <div className="productBottom horizontalBorder">
              <div className="productDetailsQuantity">
                <span>{purchaseData && purchaseData.quantity}</span> عدد موجود
                در انبار
              </div>
              <div className="productDetailsAction centeredFlex">
                <input
                  type="button"
                  onClick={() => addToCardHandler(purchaseData.id)}
                  className={`productPurchaseActionBtn ${
                    purchaseData.quantity === 0 ? "disablePurchaseBtn" : ""
                  }`}
                  value={
                    purchaseData.quantity === 0
                      ? "ناموجود"
                      : "افزودن به سبد خرید"
                  }
                  disabled={purchaseData.quantity === 0 ? true : false}
                />
                <div className="productDetailsPrice centeredFlex">
                  <p>{purchaseData && purchaseData.price.toLocaleString()}</p>
                  <span>تومان</span>
                </div>
              </div>
            </div>
          )}
        </div>
        <Modal
          show={showModal}
          onHide={handleHideModal}
          className="specificModal"
        >
          <Modal.Header className="specificModalHeader">
            <h4>{modalHeader}</h4>
            <MdClose className="specificClose" onClick={handleHideModal} />
          </Modal.Header>
          <Modal.Body className="specificModalBody">
            <p>{modalText}</p>
          </Modal.Body>
        </Modal>
        <Alert showAlert={showAlert} alertText={alertText} bottom="5rem" />
      </div>
      <BottomBar />
    </div>
  );
}
